import script from "./EditNoteTypeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditNoteTypeForm.vue?vue&type=script&setup=true&lang=js"

import "./EditNoteTypeForm.vue?vue&type=style&index=0&id=22f77551&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f77551"]])

export default __exports__